import Route from '@ember/routing/route';
import { ADMIN_USER_CONTROLLER } from 'sh-www/controllers/admin/users';

class AdminUsersRoute extends Route {
  get queryParams() {
    const queryParams = {
      page: {
        refreshModel: true
      },
      sort: {
        refreshModel: true
      },
      sortOrder: {
        refreshModel: true
      }
    };

    Object.values(ADMIN_USER_CONTROLLER.FILTERS).forEach((param) => {
      queryParams[param] = {
        refreshModel: true
      };
    });

    return queryParams;
  }

  /** @inheritDoc */
  model() {
    return {
      users: null,
    };
  }

  /** @inheritDoc */
  setupController(controller) {
    super.setupController(...arguments);

    controller.loadUsers.perform();
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadUsers.cancelAll();
      controller.resetQueryValues();
    }
  }
}

export default AdminUsersRoute;
